
export const styles = {
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
        padding: "12px 16px",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",

    },
    typography: {
        fontSize: 15,
    },
    select: {
        fontSize: 15,
    },
    menuItem: {
        fontSize: 15,
    },
    fontSizeFiftin: {
        fontSize: 15
    },
    background: {
        backgroundColor: "#EEF2F7",
        minHeight: "100vh",
    },
    title: {
        marginLeft: 10,
        fontWeight: 'bold',
    },
    divider: {
        borderBottomWidth: 1,
        height: 5,
    },
    titleTypography: {
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "16px",
        color: "#0160F1",
    },
    card: {
        backgroundColor: "#EEF2F7",
        padding: "0.8rem",

    },

    autocompleteField: {

        '& .MuiOutlinedInput-root': {
            height: '50px',
            padding: '4px 9px !important',
            alignItems: 'flex-start',
            paddingTop: '8px'
        },
        '& .MuiInputBase-input': {
            height: '100%',
            padding: '0 !important',
            boxSizing: 'border-box'
        }
    },

    totalSalesField: {
        height: '50px',
        '& .MuiInputBase-root': {
            height: '100%',
            border: '1px solid #ccc',

            borderRadius: '4px'
        },
        '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: '#555',
            color: '#555',
            cursor: 'not-allowed'
        },
        '& .MuiInputBase-input': {
            height: '100%',
            padding: '0 14px',
            boxSizing: 'border-box'
        }
    },
    selectField: {
        backgroundColor: '#fff', // Example: Ensure background consistency

    },
    toCollectField: {
        height: '50px',
        '& .MuiInputBase-root': {
            height: '100%',
            borderRadius: '4px',
            border: '1px solid #ccc'
        },
        '& .MuiInputBase-input': {
            height: '100%',
            padding: '0 14px',
            boxSizing: 'border-box'
        },

        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '& input[type=number]': {
            '-moz-appearance': 'textfield',
        },
    },
    dataGridBox: {
        backgroundColor: "#FFFFFF",
        mt: 1,
        padding: { xs: "8px", md: "0px" },
        height: { xs: 400, md: 500 },
    },
    buttonGrid: {
        display: 'flex',
        justifyContent: 'flex-end',
        pt: { xs: 2, md: 3 }
    },
    generateReportButton: {
        color: "white",

        backgroundColor: "#0160F1 !important",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        padding: "0.5rem 1.125rem",
        fontSize: "0.875rem",
        borderRadius: "0.35rem",

        "&:hover": {
            backgroundColor: "darkblue !important",
        },

        "&.Mui-disabled": {
            backgroundColor: "#aecefa !important",
            color: "#e0e0e0 !important"
        }
    }
};

export default styles;
